import React, { useEffect } from 'react'
import { urlLineLink } from '../@types/member';
import api from '../helpers/api'
import { toast } from 'react-toastify'
import { message } from 'antd';

const LineLogin = () => {

    const [messageApi, contextHolder] = message.useMessage();
    const getLinkLine = async () => {
        try {
            const res = await api.get<void, urlLineLink>('/generate-link-line')
            window.location.href = res.url;
        } catch ({ message }: any) {
            // toast.error(message as string)
            messageApi.open({
                type: 'error',
                content: message as string,
            });
        }
    }

    useEffect(() => {
        getLinkLine()
    }, [])

    return (
        <>{contextHolder}</>
    )
}

export default LineLogin